import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine } from 'recharts'
import type { AnalyticsValidationPoint } from '../../types/dashboard'
import { formatChartDate, tickInterval } from './chartUtils'

const SERIES_COLOR = '#3987e5'
const GRID_COLOR = 'rgba(255,255,255,0.07)'
const AXIS_COLOR = '#8888a0'
const THRESHOLD_COLOR = '#555568'

interface ValidationScoreChartProps {
  data: AnalyticsValidationPoint[]
  minValidationScore: number
}

export default function ValidationScoreChart({ data, minValidationScore }: ValidationScoreChartProps) {
  return (
    <div className="bg-rd-surface border border-white/[0.07] rounded-xl p-4">
      <p className="text-xs text-rd-muted mb-3">Validation score</p>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data} margin={{ top: 4, right: 56, bottom: 0, left: 0 }}>
          <CartesianGrid stroke={GRID_COLOR} vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={formatChartDate}
            interval={tickInterval(data.length)}
            tick={{ fill: AXIS_COLOR, fontSize: 11 }}
            axisLine={{ stroke: GRID_COLOR }}
            tickLine={false}
          />
          <YAxis domain={[0, 100]} tick={{ fill: AXIS_COLOR, fontSize: 11 }} axisLine={false} tickLine={false} width={28} />
          <Tooltip
            contentStyle={{ background: '#1a1a26', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8, fontSize: 12 }}
            labelStyle={{ color: '#f0f0f5' }}
            itemStyle={{ color: '#f0f0f5' }}
            cursor={{ stroke: GRID_COLOR }}
          />
          <ReferenceLine
            y={minValidationScore}
            stroke={THRESHOLD_COLOR}
            strokeDasharray="4 4"
            label={{ value: `Min (${minValidationScore})`, fill: THRESHOLD_COLOR, fontSize: 11, position: 'right' }}
          />
          <Line
            type="monotone"
            dataKey="avg_validation_score"
            name="Avg. validation score"
            stroke={SERIES_COLOR}
            strokeWidth={2}
            dot={{ r: 3, fill: SERIES_COLOR }}
            connectNulls
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
